export const COURSE_FEATURE_FLAG = 'COURSE_MVP';

export const coursesPath = () => '/cursos';

export const coursePath = (courseSlug: string) => `${coursesPath()}/${courseSlug}`;

export const tracksPath = () => `${coursesPath()}/trilhas`;
export const trackPath = (trackSlug: string) => `${tracksPath()}/${trackSlug}`;
export const courseInTrackPath = (trackSlug: string, courseSlug: string) => `${trackPath(trackSlug)}/${courseSlug}`;

export type CourseRouteOptions = { trackSlug?: string };

export const courseModulePath = (courseSlug: string, moduleSlug: string, options: CourseRouteOptions = {}) =>
  options.trackSlug
    ? `${courseInTrackPath(options.trackSlug, courseSlug)}/${moduleSlug}`
    : `${coursePath(courseSlug)}/${moduleSlug}`;

export const courseTrackPath = (trackSlug: string, courseSlug: string) => courseInTrackPath(trackSlug, courseSlug);

export const courseTopicPath = (
  courseSlug: string,
  moduleSlug: string,
  topicSlug: string,
  options: CourseRouteOptions = {},
) => `${courseModulePath(courseSlug, moduleSlug, options)}/${topicSlug}`;
